import React from 'react';
import {
  Grid,
  TextField,
} from "@material-ui/core";
import {
  KeyboardDatePicker
} from '@material-ui/pickers';
import { Controller } from 'react-hook-form';

function LessonForm(props){
  const { isEditableForm } = props;
  const { name, end_date } = props.data || {};  
  const { register, errors, control } = props.formConfig; 
  
  return (
    <form noValidate autoComplete="off" >      
        <Grid container spacing={3} direction="row">
          <Grid item xs={6}>
            <TextField 
              id="filled-basic"
              label="Name"
              name="name"
              placeholder="Lesson name"
              variant="filled"
              disabled={!isEditableForm}
              fullWidth={true}

              defaultValue={name}
              inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
              error={errors.name ? true : false}
              helperText={errors.name ? errors.name.message : null}
            />
          </Grid>

          <Grid  item xs={6}>
            <Controller 
              as={KeyboardDatePicker}
              autoOk
              format="MM/DD/YYYY"
              views={["year", "month", "date"]}
              label="Due Date"
              placeholder="mm/dd/yyyy"
              variant="inline"    
              inputVariant="filled"
              fullWidth={true} 
              error={errors.end_date ? true : false}
              helperText={errors.end_date ? errors.end_date.message : null}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              // rules={{ required: "Field Required", pattern: /^[A-Za-z]+$/i  }}
              name="end_date"               
              control={control} 
              defaultValue={end_date || null} />
          </Grid>

              
          {/* Show Form action buttons only when Edit action is active */}
          {props.children}
        </Grid>
    </form>
  )
}

export default LessonForm;